import NfcCardTransactionsTable from './NfcCardTransactionsTable';

export default NfcCardTransactionsTable;
